import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
// Initialise i18next before the App tree mounts so the very first render
// already speaks the right language (avoids a flash-of-English).
import './i18n';
import { App } from './app';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
